import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import RaisingHands from '../../Assets/Images/raising-hands.png'
import WestIcon from '@mui/icons-material/West'
import EastIcon from '@mui/icons-material/East'
import { useState, useEffect, useContext } from 'react'
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext'
import useEnsureAssessmentDetails from '../../Hooks/useEnsureAssessmentDetails';

const GetStarted = () => {

  const params = useParams()
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  const location = useLocation()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const assessCtx = useContext(AssessmentQuestionContext);
  const { id } = useParams();
  useEnsureAssessmentDetails(id, searchParams);

  const leader = location.state?.leader;
  const member = location.state?.member;
  const respondentName = location.state?.respondentName;
  const navigationSearch = () => {
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));
    return navigationParams.toString();
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    assessCtx?.setLeaderName(storedData.leader)
  }, [])



  console.log("leader", leader)

  const handleBack = () => {
    navigate(`/walkthrough/${params.id}/?${navigationSearch()}`, {
      replace: true,
      state: { activeStep: 2, fromGetStarted: true },
    });
  };

  const handleNext = () => {
    navigate(`/assessment/${params.id}/866/`, { replace: true });
  }

  console.log("searchParams", searchParams)

  return (
    <div className="get-started-container">
      <div className="get-started">

        <img src={RaisingHands} alt='' style={{ width: "60px", height: "60px", }} />
        <div className="perfect">Perfect!</div>
        <p className="set-to-begin">You're all set to begin.</p>
        <div className="buttons">
          {/* {windowWidth > 650 ?  */}
          <button
            className="back-btn"
            onClick={handleBack}
          // disabled={currentIndex === 0}
          >
            < WestIcon /> Back
          </button>
          {/* : null} */}
          <button
            className="next-btn"
            onClick={() => handleNext()}
          >
            Get Started <EastIcon />
          </button>
        </div>
        {/* <button className="next-btn" 
        onClick={handleNext} 
        // disabled={currentIndex === categories.length - 1}
				>
        Get Started
      </button> */}

        <div className="get-started-note">
          {/* <p className='get-started-text' style={{ textAlign: windowWidth < 600 ? 'center' : 'center', letterSpacing: 0 }}>👉 <strong>Note:</strong> Your progress is automatically saved. {windowWidth < 600 && <br/>} You can close the page and return anytime <br/> using the link in your email to pick up {windowWidth < 600 && <br/>} where you left off.</p> */}
          {
            windowWidth > 600 ?
              <p className='get-started-text' style={{ textAlign: windowWidth < 600 ? 'center' : 'center', letterSpacing: 0 }}>👉 <strong>Note:</strong> While there is the option to save progress, we strongly recommend that you begin <br /> when you are available for 30 minutes {windowWidth < 600 && <br />} to answer all questions in one sitting.</p>
              :
              <p className='get-started-text' style={{ textAlign: windowWidth < 600 ? 'center' : 'center', letterSpacing: 0 }}>👉 <strong>Note:</strong> While there is the option to save progress, <br />we strongly recommend that you begin <br /> when you are available for 30 minutes {windowWidth < 600 && <br />} to answer all questions in one sitting.</p>
          }
        </div>
      </div>
    </div>
  )
}

export default GetStarted;
